import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { BaseService } from './core/services/shared/base.service';
import { CommonService } from './core/services/v2/common.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';
  showFooter = true;
  isLoggedIn;
  constructor(private route: ActivatedRoute, private router: Router, @Inject(DOCUMENT) private document: any, private commonService: CommonService) {
  }

  ngOnInit(): void {
    //const subscription = this.router.events.subscribe((event) => {
    //  if (event instanceof NavigationStart) {
    //    if (!event.url.includes('flag')) {
    //      // remove queryParams
    //      const url = event.url;
    //      if (url !== '/') {
    //        const newUrl = url.split('/').filter(_subUrl => _subUrl);
    //        this.router.navigate(newUrl, { queryParams: { flag: Math.random() }, queryParamsHandling: 'merge' });
    //      }
    //    }
    //  }
    //});
    //setTimeout(() => subscription.unsubscribe(), 3000);
  }

  checkLogin(url: string) {
    this.router.navigate([url]);

    //this.userService.isLoggedIn()
    //  .subscribe(result => {
    //      this.router.navigate([url]);
    //    },
    //    error => {
    //      this.document.location.href = '/Session/SignIn';
    //    });
  }
}
